import { useState, useRef, useEffect, useCallback } from 'react';
import braintreeClient from 'braintree-web/client';
import paypalClient from 'braintree-web/paypal';
import { usePaymentMethodSelectContext } from '../PaymentMethodSelectContext';

export function usePayPalClient(clientToken: string): $TSFixMe {
    const [paypalState, setPaypalState] = useState(null);
    const paypalPromise = useRef<Promise<{ paypal: $TSFixMe }> | null>(null);

    const { paymentMethodOptions } = usePaymentMethodSelectContext();

    const handleSetupError = useCallback(
        (error: unknown) => {
            paymentMethodOptions?.PAYPAL_ACCOUNT?.onSetupError?.(error);
        },
        [paymentMethodOptions]
    );

    useEffect(() => {
        paypalPromise.current = new Promise(resolve => {
            braintreeClient.create(
                { authorization: clientToken },
                (clientError: $TSFixMe, clientInstance: $TSFixMe) => {
                    if (clientError) {
                        handleSetupError(clientError);
                        return;
                    }

                    paypalClient.create(
                        {
                            client: clientInstance,
                        },
                        (payPalError: $TSFixMe, paypal: $TSFixMe) => {
                            if (payPalError) {
                                handleSetupError(payPalError);
                                return;
                            }
                            resolve({ paypal });
                            setPaypalState(paypal);
                        }
                    );
                }
            );
        });
        return () => {
            if (paypalPromise.current) {
                paypalPromise.current.then(({ paypal }) => paypal.teardown());
            }
        };
    }, [clientToken, handleSetupError]);

    return paypalState;
}
